import { AssessmentQuality } from '../models/assessment.types';
import { ToleranceType } from '../pages/Sessions/SessionsParametersDialog/ToleranceRange/ToleranceRange.types';
import { AssessmentSessionProcessTypeId } from '../services/exams/assessmentSession/assessments.types';

export const getColor = (
  assessmentQuality: AssessmentQuality | null,
  processTypeId?: AssessmentSessionProcessTypeId,
): string => {
  switch (assessmentQuality) {
    case AssessmentQuality.Accurate:
      return '#347F42';

    case AssessmentQuality.Inaccurate:
      return '#BC0000';

    case AssessmentQuality.WithinTolerance:
      return processTypeId !== undefined && processTypeId === AssessmentSessionProcessTypeId.Training
        ? '#BC0000'
        : '#FF9A02';

    default:
      return '#3C419A';
  }
};

export const getAssessmentQualityLabel = (
  processTypeId: AssessmentSessionProcessTypeId,
  assessmentQuality: AssessmentQuality | null,
): string => {
  switch (assessmentQuality) {
    case AssessmentQuality.Accurate:
      return 'Ocena dokładna';

    case AssessmentQuality.Inaccurate:
      return processTypeId === AssessmentSessionProcessTypeId.Qualification
        ? 'Ocena poza zakresem tolerancji'
        : 'Wystąpiły rozbieżności w ocenie';

    case AssessmentQuality.WithinTolerance:
      return processTypeId === AssessmentSessionProcessTypeId.Qualification
        ? 'Ocena w zakresie tolerancji'
        : 'Wystąpiły rozbieżności w ocenie';

    default:
      return '';
  }
};

export const getPillTooltip = (
  processTypeId: AssessmentSessionProcessTypeId,
  toleranceType?: ToleranceType,
  toleranceRange?: number,
) => {
  return toleranceType !== undefined
    ? `warunek tolerancji - ${
        toleranceType === ToleranceType.RelativeDifference ? 'różnica ocen' : 'bezwzględna różnica ocen'
      }: ${toleranceRange}`
    : '';
};
